export default class AlertHandler {
  constructor({type, alertType, alertText, appendSelector}) {
    this.type = type;
    this.alertType = alertType;
    this.alertText = alertText;
    this.selector = appendSelector;
  }
  show() {
    if (this.type === "productpage" && this.alertType === "modal") {
      this.showModalAlert();
    } else if (this.type === "quickview" || this.alertType === "inline") {
      this.showAlertBox();
    }
  }
  hide() {
    if (this.alertType === "modal") {
      this.hideModalAlert();
    } else if (this.alertType === "inline") {
      this.removeAlertBox();
    }
  }
  showAlertBox() {
    const $el = $(this.selector);
    this.removeAlertBox($el);
    const $alert = $("<div>");
    $alert.addClass("alert alert-danger attribute-alert").text(this.alertText);
    $el.prepend($alert);
  }
  removeAlertBox() {
    const $el = $(this.selector);
    const $oldAlert = $el.find(".attribute-alert");
    if ($oldAlert) {
      $oldAlert.remove();
    }
  }
  showModalAlert() {
    const $modal = $("#force-attributes-modal");
    $modal.modal("show");
  }
  hideModalAlert() {
    const $modal = $("#force-attributes-modal");
    $modal.modal("hide");
  }
}
